export const isImpersonating = (): boolean => {
  const trueUser = window["$rootScope"]["trueUser"];
  const user = window["$rootScope"]["user"];

  if (!trueUser || !user) return false;
  return trueUser.id != user.id;
};

export const trueUserName = (): string => {
  const trueUser = window["$rootScope"]["trueUser"];

  if (!trueUser) return "";
  return trueUser.first_name + " " + trueUser.last_name;
};

export const userName = (): string => {
  const user = window["$rootScope"]["user"];

  if (!user) return "";
  return user.first_name + " " + user.last_name;
};
